import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, trackPageView } from '../lib/analytics';

export const AnalyticsTracker = () => {
  const { pathname, search } = useLocation();

  useEffect(() => { initAnalytics(); }, []);

  useEffect(() => {
    if (pathname.startsWith('/admin')) return;
    const t = setTimeout(() => trackPageView(pathname + search, document.title), 300);
    return () => clearTimeout(t);
  }, [pathname, search]);

  return null;
};

export default AnalyticsTracker;
